import { Link } from "react-router-dom";
import SEO from "../components/SEO";

/**
 * 404 — "Lost in the Pasture."
 * A farmhouse-styled soft landing that keeps the storybook tone.
 */
export default function NotFound() {
  return (
    <div
      className="parchment min-h-screen flex items-center justify-center px-6 pt-24 pb-24"
      data-testid="not-found-page"
    >
      <SEO
        title="Lost in the Pasture · The Salty Moo™"
        description="This page seems to have wandered off. Let's walk you back to the barn."
        path="/404"
      />
      <div className="parchment-deep page-shadow border border-[#E7DFD5] rounded-md max-w-xl w-full text-center px-10 py-14">
        <p className="text-xs uppercase tracking-[0.4em] text-[#D62839] mb-4">
          Chapter Not Found
        </p>
        <h1 className="font-display text-5xl md:text-6xl text-[#4B3A2F] leading-tight mb-4">
          Lost in the Pasture
        </h1>
        <div className="gold-rule mx-auto w-24 mb-6" />
        <p className="font-script text-3xl text-[#4B3A2F] mb-3">
          well, this page wandered off…
        </p>
        <p className="font-body text-lg text-[#2C2724]/85 leading-relaxed mb-9">
          Maybe it slipped through a gate, or maybe Peek-a-Moo™ tucked it
          somewhere quiet. Either way — let&rsquo;s walk you back to the barn.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-btn"
          className="btn-pasture inline-flex items-center justify-center"
        >
          Back to the barn doors
        </Link>
      </div>
    </div>
  );
}
